import React from 'react';

interface Props {
  company?: string;
  companyUrl?: string;
  className?: string;
}

const ArticleAuthorCompany = ({ company, companyUrl, className }: Props) => {
  if (!company) {
    return null;
  }

  const inner = companyUrl ? (
    <a href={companyUrl} target='_blank' rel='noreferrer'>
      {company}
    </a>
  ) : (
    company
  );

  return <p className={className}>{inner}</p>;
};

export default ArticleAuthorCompany;
